export enum DiversionManagerAirlineEnum {
    airline = 0,
    major = 1
}
export enum DiversionManagerNetworkEnum {
    network = 0,
    subCarrier = 1
}

export enum DiversionManagerOtherEnum {
    other = 0,
    oal = 1
}

export enum DiversionManagerCapacityFieldEnum {
    total = 0,
    narrow = 1,
    wideNarrow = 2
}

export enum DiversionPriorityTypeEnum {
    faa = 0,
    custom = 1
}
